import type { MonthStatus } from './types';

export function monthName(m: number) {
  return new Date(2000, m - 1, 1).toLocaleString(undefined, { month: 'short' });
}

export function fmt(n: number) {
  return Number.isFinite(n) ? n.toFixed(2) : '-';
}

export function monthKey(year: number, month: number) {
  return `${year}-${month}`;
}

export function statusChipColors(status: MonthStatus) {
  switch (status) {
    case 'ok':
      return {
        bgColor: '#eaf7ee',
        textColor: '#2e7d32',
      };
    case 'partial':
      return {
        bgColor: '#fff4e5',
        textColor: '#a15c00',
      };
    case 'missing':
      return {
        bgColor: '#f0f0f0',
        textColor: '#aaaaaa',
      };
    default:
      return {
        bgColor: '#fdecea',
        textColor: '#b3261e',
      };
  }
}
